import React from 'react';

interface OverlapChartProps {
  leftCircle: {
    value: number;
    label: string;
    color?: string;
  };
  rightCircle: {
    value: number;
    label: string;
    color?: string;
  };
  overlapValue?: number;
  title?: string;
  className?: string;
}

const OverlapChart: React.FC<OverlapChartProps> = ({
  leftCircle,
  rightCircle,
  overlapValue,
  title,
  className
}) => {
  return (
    <div className={`bg-gray-900 rounded-lg p-4 ${className}`}>
      {title && (
        <div className="text-gray-900 text-sm font-medium mb-3">{title}</div>
      )}
      
      <div className="relative w-full h-32 flex items-center justify-center">
        <svg viewBox="0 0 200 100" className="w-full h-full">
          {/* Left circle */}
          <circle
            cx="60"
            cy="50" 
            r="35"
            fill={leftCircle.color || '#3B82F6'}
            opacity="0.7"
            stroke="white"
            strokeWidth="1"
          />
          
          {/* Right circle */}
          <circle
            cx="140"
            cy="50"
            r="35" 
            fill={rightCircle.color || '#10B981'}
            opacity="0.7"
            stroke="white"
            strokeWidth="1"
          />
          
          {/* Left circle value */}
          <text
            x="45"
            y="50"
            textAnchor="middle"
            fill="white"
            fontSize="12"
            fontWeight="bold"
          >
            {leftCircle.value}
          </text>
          
          {/* Right circle value */}
          <text
            x="155"
            y="50"
            textAnchor="middle"
            fill="white"
            fontSize="12"
            fontWeight="bold"
          >
            {rightCircle.value}
          </text>
          
          {/* Overlap value */}
          {overlapValue && (
            <text
              x="100"
              y="50"
              textAnchor="middle"
              fill="white"
              fontSize="10"
              fontWeight="bold"
            >
              {overlapValue}%
            </text>
          )}
          
          {/* Left label */}
          <text
            x="45"
            y="75"
            textAnchor="middle"
            fill="white"
            fontSize="8"
          >
            {leftCircle.label}
          </text>
          
          {/* Right label */}
          <text
            x="155"
            y="75"
            textAnchor="middle"
            fill="white"
            fontSize="8"
          >
            {rightCircle.label}
          </text>
        </svg>
      </div>
      
      <div className="text-center mt-2">
        <div className="text-xs text-gray-600">
          {leftCircle.label}: {leftCircle.value} • {rightCircle.label}: {rightCircle.value}
        </div>
        {overlapValue && (
          <div className="text-xs text-gray-400 mt-1">
            Overlap: {overlapValue}%
          </div>
        )}
      </div>
    </div>
  );
};

export default OverlapChart;